(() => {
  'use strict';
  if (window.gtoAvailabilityOrder17) return;
  window.gtoAvailabilityOrder17 = true;

  const handled = new WeakSet();
  const states = new Map([['available', 0], ['tbd', 1], ['hold', 1], ['unavailable', 1], ['sold', 2], ['other', 3]]);
  let active;
  let scheduled = false;

  function cardsFor(grid) {
    return Array.from(grid.children).filter((card) => card.matches('li[data-gto-product-id]'));
  }

  function preservePreviewLinks(container, url) {
    const preview = url.searchParams.get('preview_theme_id');
    if (!preview) return;
    container.querySelectorAll('.pagination a[href]').forEach((link) => {
      const target = new URL(link.href, url);
      if (target.origin !== url.origin) return;
      target.searchParams.set('preview_theme_id', preview);
      link.href = target.pathname + target.search + target.hash;
    });
  }

  async function reorder(grid) {
    if (handled.has(grid)) return;
    handled.add(grid);
    active?.abort();
    const controller = new AbortController();
    active = controller;
    const container = grid.closest('#ProductGridContainer');
    const section = grid.closest('.shopify-section') || document;
    const status = container.querySelector('[data-gto-order-status]');
    const url = new URL(window.location.href);
    const defaultSort = grid.dataset.gtoDefaultSort;
    const selectedSort = url.searchParams.get('sort_by');
    section.querySelectorAll('select[name="sort_by"] option').forEach((option) => {
      if (option.value === defaultSort) option.textContent = grid.dataset.gtoOrderLabel;
    });
    preservePreviewLinks(container, url);
    if (selectedSort && selectedSort !== defaultSort) return;

    const page = Number(grid.dataset.gtoOrderPage);
    const pages = Number(grid.dataset.gtoOrderPages);
    const size = Number(grid.dataset.gtoOrderSize);
    const total = Number(grid.dataset.gtoOrderTotal);
    const sectionId = grid.dataset.id;
    const pageParam = grid.dataset.gtoOrderParam || 'page';
    if (![page, pages, size, total].every(Number.isSafeInteger) || page < 1 || pages < 1 || page > pages || size < 1 || total < 1 || pages > 100 || !sectionId) return;
    const snapshot = url.pathname + url.search;
    const pageCards = new Array(pages);
    pageCards[page - 1] = cardsFor(grid);
    const queue = Array.from({ length: pages }, (_, i) => i + 1).filter((number) => number !== page);
    const timer = window.setTimeout(() => controller.abort(), 20000);
    grid.setAttribute('aria-busy', 'true');
    if (status) {
      status.textContent = grid.dataset.gtoOrderLoading;
      status.hidden = false;
    }

    try {
      async function worker() {
        while (queue.length) {
          const number = queue.shift();
          const target = new URL(url);
          target.hash = '';
          target.searchParams.delete('sections');
          target.searchParams.set('section_id', sectionId);
          target.searchParams.set(pageParam, String(number));
          const response = await fetch(target, {
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'text/html' },
            signal: controller.signal
          });
          if (!response.ok) throw new Error('Collection page unavailable');
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const fetchedGrid = parsed.querySelector('[data-gto-order-grid]');
          if (!fetchedGrid || fetchedGrid.dataset.id !== sectionId || Number(fetchedGrid.dataset.gtoOrderPage) !== number || Number(fetchedGrid.dataset.gtoOrderTotal) !== total || Number(fetchedGrid.dataset.gtoOrderPages) !== pages) {
            throw new Error('Collection changed during loading');
          }
          pageCards[number - 1] = cardsFor(fetchedGrid);
        }
      }
      await Promise.all(Array.from({ length: Math.min(3, queue.length) }, () => worker()));
      if (controller.signal.aborted || !grid.isConnected || window.location.pathname + window.location.search !== snapshot) return;
      const cards = pageCards.flat();
      const ids = new Set(cards.map((card) => card.dataset.gtoProductId));
      if (cards.length !== total || ids.size !== total || cards.some((card) => !states.has(card.querySelector('[data-gto-availability]')?.dataset.gtoAvailability))) {
        throw new Error('Incomplete collection');
      }
      const groups = [[], [], [], []];
      cards.forEach((card) => groups[states.get(card.querySelector('[data-gto-availability]').dataset.gtoAvailability)].push(card));
      const visible = groups.flat().slice((page - 1) * size, page * size);
      const fragment = document.createDocumentFragment();
      visible.forEach((card, index) => {
        const node = document.importNode(card, true);
        node.classList.remove('scroll-trigger', 'scroll-trigger--offscreen', 'animate--slide-in');
        node.style.setProperty('--animation-order', String(index + 1));
        fragment.append(node);
      });
      grid.replaceChildren(fragment);
      grid.dataset.gtoOrderApplied = 'true';
      if (status) {
        status.textContent = '';
        status.hidden = true;
      }
    } catch {
      controller.abort();
      if (grid.isConnected && active === controller && status) {
        status.textContent = grid.dataset.gtoOrderFallback;
        status.hidden = false;
      }
    } finally {
      window.clearTimeout(timer);
      grid.removeAttribute('aria-busy');
    }
  }

  function scan() {
    scheduled = false;
    document.querySelectorAll('[data-gto-order-grid]').forEach((grid) => void reorder(grid));
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(scan);
  }

  function start() {
    const main = document.getElementById('MainContent');
    if (!main) return;
    new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', schedule);
    scan();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
